<template>
  <v-form v-model="valid" ref="form">
    <v-dialog overlay-opacity="0.7" v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('delete_education')}}</v-card-title>
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="error" @click="deleteComponent(detail)" :loading="loading">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card class="pt-3 container">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row>
            <v-col md="12">
              <v-card-title>
                <span class="headline">{{$t('education_list')}}</span>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :loading="loading"
                  :headers="headers"
                  :items="educationList"
                  :hide-default-footer="true"
                  :no-data-text="$t('no_data')"
                >
                  <template v-slot:item.no="{index}">{{index+1}}</template>
                  <template v-slot:item.action="{item}">
                    <v-btn plain class="primary--text" @click="seeDetail(item)">{{$t('see_details')}}</v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-col>
            <v-col md="12" class="pt-0">
              <div class="sae-grey" @click="add">
                <v-icon class="ml-2">mdi-plus</v-icon>
                <span class="ml-4">{{$t('education_list')}}</span>
              </div>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-row>
            <v-col md="6">
              <v-btn icon @click="tab = 0;isEdit = false">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>{{$t('back')}}
            </v-col>
            <v-col md="6" class="text-right" v-if="isEdit">
              <v-btn icon @click="deleteItem(detail)" color="error">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-row align="center">
                <v-divider></v-divider>
                <v-btn plain disabled>{{$t('education_detail')}}</v-btn>
                <v-divider></v-divider>
              </v-row>
            </v-col>
            <v-col md="12">
              <v-select
               :label="$t('educational_level')"
                v-model="detail.educationLevel"
                :rules="rules2"
                :items="educationalLevelList"
                item-text="nameId"
                item-value="id"
                required
                class="sae-required"
              ></v-select>
            </v-col>
            <v-col md="12" class="pb-0">
              <v-text-field
                :label="$t('institution')"
                v-model="detail.institution"
                type="text"
                :rules="[...rules, validator.alfaNumberNotRequired]"
                required
                class="sae-required"
              ></v-text-field>
            </v-col>
            <v-col md="6">
              <v-menu
                ref="menu"
                v-model="menuStart"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="dateFormatted(detail.startDate)"
                   :label="$t('start_date')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    color="primary"
                    :rules="rules"
                    required
                    class="sae-required"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="detail.startDate"
                  @change="onStartDateChange"
                  no-title
                  scrollable
                  :locale="$t('locale')"
                  :max="maxDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col md="6" class="pb-0">
              <v-text-field
               :label="$t('end_year')"
                v-model="detail.endYear"
                type="number"
                max="4"
                :rules="rules3"
                required
                class="sae-required"
              ></v-text-field>
            </v-col>
            <v-col md="12">
              <v-text-field
                :label="$t('major')"
                v-model="detail.major"
                type="text"
                :rules="[...rules, validator.alfaNumberNotRequired]"
                required
                class="sae-required"
              ></v-text-field>
            </v-col>
            <v-col md="12">
              <v-text-field
               :label="$t('gpa')"
                v-model="detail.GPA"
                type="number"
                :rules="[...rules4, validator.numberNotRequired]"
                required
                class="sae-required"
              ></v-text-field>
            </v-col>
            <v-col cols="12" v-if="detail.certificate">
              <v-row align="center">
                <v-divider></v-divider>
                <v-btn plain disabled>{{$t('certficates')}}</v-btn>
                <v-divider></v-divider>
              </v-row>
            </v-col>
            <!-- v-if="!isEdit" -->
            <v-col cols="12" class="text-right">
              <v-btn @click="addAttachment">
                <v-icon>mdi-plus</v-icon>{{$t('certificate')}}
              </v-btn>
            </v-col>
            <v-col md="12" v-for="(item,i) in detail.certificate" v-bind:key="i">
              <v-row>
                <v-col cols="6">
                  <!-- :readonly="isEdit" -->
                  <v-text-field
                    :label="`${$t('certificate_name')} ${i+1}`"
                    v-model="item.certificateName"
                    :rules="[...rules, validator.alfaNumberNotRequired]"
                    :readonly="isEdit"
                    required
                    class="sae-required"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <!-- :readonly="isEdit" -->
                  <v-text-field
                    :label="`${$t('certificate_number')} ${i+1}`"
                    v-model="item.certificateNumber"
                    :rules="[...rules, validator.alfaNumberNotRequired]"
                    :readonly="isEdit"
                    required
                    class="sae-required"
                  ></v-text-field>
                </v-col>
                <!-- i+1 == detail.certificate.length &&  -->
                <!-- v-if="!isEdit" -->
                <v-col cols="1">
                  <v-btn icon color="error" class="mt-4" @click="deleteCertificate(i, item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <!-- <v-text-field
                    :value="dateFormatted(item.certificateDate)"
                    :label="`Certificate Date ${i+1}`"
                    prepend-icon="mdi-calendar"
                    readonly
                    color="primary"
                    :rules="rules"
                    class="sae-required"
                    v-if="isEdit"
                  ></v-text-field> -->
                  <!-- v-if="!isEdit" -->
                  <v-menu
                    ref="menu"
                    v-model="menuStart2[i]"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="dateFormatted(item.certificateDate)"
                        :label="`${$t('certificate_date')} ${i+1}`"
                        prepend-icon="mdi-calendar"
                        v-on="on"
                        color="primary"
                        :rules="rules"
                        required
                        class="sae-required"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="item.certificateDate"
                      @change="onStartDateChange2(i)"
                      no-title
                      scrollable
                      :locale="$t('locale')"
                      :max="maxDate"
                      show-current="false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6" class="text-left">
                  <v-btn
                    class="mt-4"
                    block
                    outlined
                    v-if="isEdit && item.attachmentUrl"
                    :href="item.attachmentUrl"
                    target="_blank"
                  >
                    <v-icon color="primary">{{getExtension(item.attachment)}}</v-icon>
                    &nbsp;{{`${$t('certificate')} ${i+1}`}}
                    <div class="flex-grow-1"></div>
                  </v-btn>
                  <!-- v-if="!isEdit" -->
                  <v-file-input
                    :label="`${$t('certificate')} ${i+1}`"
                    accept="image/*, application/pdf"
                    v-model="item.file"
                    @change="uploadImage(item.file, item)"
                    :rules="item.attachmentUrl ? [] : rules"
                    required
                    class="sae-required"
                  ></v-file-input>
                  <v-progress-linear v-show="item.loading" :value="item.progress"></v-progress-linear>
                </v-col>
              </v-row>
            </v-col>
            <v-col md="12" class="text-center">
              <v-btn plain class="ma-2 primary--text" @click="tab=0;reload();isEdit=false">{{$t('cancel')}}</v-btn>
              <v-btn
                color="primary"
                class="ma-2"
                :loading="loading"
                :disabled="!valid"
                @click="saveOrUpdate(detail)"
              >{{$t('save')}}</v-btn>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-form>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import ENV from './../../../../store/modules/environtment'

export default {
  props: ['userId', 'educationList'],
  name: "Education-List",
  data() {
    return {
      headers: [
        { text: "No", value: "no" },
        { text: this.$i18n.t('educational_level'), value: "educationLevel" },
        { text: this.$i18n.t('institution'), value: "institution" },
        { text: this.$i18n.t('end_year'), value: "endYear" },
        { text: "", value: "action" },
      ],
      rules: [(value) => (value === 0 ? true : !!value || this.$i18n.t('required'))],
      rules2: [(value) => (value == 0 ? false || this.$i18n.t('required') : value ? value > 0 : !!value || this.$i18n.t('required'))],
      rules3: [
        v => (v && v.length == 4) || this.$i18n.t('year_required'),
        v => /^[0-9]+$/.test(v) || this.$i18n.t('number_required'),
        v => (v && v >= parseInt(moment(this.detail.startDate).format('YYYY'))) || `Please input above ${parseInt(moment(this.detail.startDate).format('YYYY'))}`,
        v => (v && v <= parseInt(moment(this.detail.startDate).format('YYYY')) + 10) || `Please input below ${parseInt(moment(this.detail.startDate).format('YYYY')) + 10}`,
      ],
      rules4: [
        v => /^[0-9.,]+$/.test(v) || this.$i18n.t('number_required'),
        (value) => (value === 0 ? true : !!value || this.$i18n.t('required'))
      ],
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      valid: false,
      formData: [],
      userIdLogin: this.$store.getters.user.id,
      loading: false,
      tab: 0,
      detail: { startDate: null, certificate: [] },
      isEdit: false,
      deleteDialog: false,
      menuStart: false,
      menuStart2: [false],
      educationalLevelList: [
        { id: 1, nameId: 'Sekolah Dasar' },
        { id: 2, nameId: 'Sekolah Menengah Pertama' },
        { id: 3, nameId: 'Sekolah Menengah Atas' },
        { id: 4, nameId: 'Sekolah Menengah Kejuruan' },
        { id: 5, nameId: 'Diploma' },
        { id: 6, nameId: 'Strata 1' },
        { id: 7, nameId: 'Pascasarjana' },
        { id: 8, nameId: 'Pengangguran' },
      ],
      maxDate: moment().subtract(1, 'day').locale(this.$i18n.t('lang')).format('YYYY-MM-DD'),
    }
  },
  methods: {
    async deleteCertificate(i, item) {
      this.detail.certificate.splice(i, 1)
      if (item.id) {
        await this.$store.dispatch('deleteEducationsCertificate', item)
      }
    },
    addAttachment() {
      this.detail.certificate.push({
        certificateName: '',
        certificateNumber: '',
        certificateDate: this.maxDate,
        attachmentPrefix: '',
        attachment: '',
        progress: 0,
        loading: false,
      })
    },
    add() {
      this.isEdit = false
      this.detail = { userId: this.userId, startDate: null, certificate: [] }
      this.tab = 1
    },
    seeDetail(item) {
      this.isEdit = true
      this.detail = Object.assign({ userId: this.userId, certificate: [] }, item)
      this.detail.startDate = moment(item.startDate).locale(this.$i18n.t('lang')).format('YYYY-MM-DD')
      this.detail.endYear = this.detail.endYear.toString()
      this.detail.educationLevel = this.detail.educationLevelId
      this.detail.certificate = []
      this.detail.certificates.map(data => {
        const result = Object.assign({}, data)
        result.certificateDate = moment(result.certificateDate).locale(this.$i18n.t('lang')).format('YYYY-MM-DD')
        this.detail.certificate.push(result)
      })
      this.tab = 1
    },
    costumHeader(actionId, action) {
      return { headers: { actionId, action } }
    },
    formatTime(date) {
      return moment(date).locale(this.$i18n.t('lang')).format('Do MMMM YYYY')
    },
    dateFormatted(date) {
      if (date) return moment(date).locale(this.$i18n.t('lang')).format('Do MMMM YYYY');
      return null
    },
    onStartDateChange() {
      this.menuStart = false;
    },
    onStartDateChange2(i) {
      this.menuStart2[i] = false;
    },
    getExtension(attachment = '') {
      const ext = attachment.split('.')
      switch (ext[ext.length - 1]) {
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'gif':
          return 'mdi-file-image-outline'

        default:
          return 'mdi-attachment'
      }
    },
    async getEducationLevel() {
      this.loading = true
      this.educationalLevelList = await this.$store.dispatch('getEducationLevel')
      this.loading = false
    },
    getParentData() {
      this.formData = this.educationList
    },
    async uploadImage(image, item) {
      if (!image) return null
      const companyId = this.$store.state.company
      const prefix = `${ENV.firebase.prifixEmployee}${companyId}/${this.userId}/master_employee/education`
      const url = `${this.baseUrl}/download/file_upload_general`
      const headers = { headers: { 'Content-Type': 'multipart/form-data', action: 'File Upload', actionId: 1 } }
      try {
        const formData = new FormData();
        formData.append('file', image)
        formData.append('path', `${prefix}`)
        item.loading = true
        const result = await axios.post(url, formData, {
          ...headers,
          onUploadProgress: (e) => {
            item.progress = Math.round(e.loaded / e.total * 100)
          }
        })
        item.loading = false
        if (result) {
          if (result.data.code == 200) {
            item.attachmentPrefix = result.data.data.path
            item.attachment = result.data.data.fileName
            return result.data.data
          }
        }
        return { url: 'img/default-image.png' }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e.message)
        item.loading = false
        return { url: 'img/default-image.png' }
      }
    },
    async saveOrUpdate(data) {
      if (this.isEdit) {
        this.editComponent(data)
      } else {
        this.saveComponent(data)
      }
    },
    async saveComponent(data) {
      const body = { ...data, levelId: data.educationLevel }
      this.loading = true
      const result = await this.$store.dispatch('saveEducation', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.$emit('reload', true)
        this.tab = 0
      }
    },
    async editComponent(data) {
      const body = { ...data, levelId: data.educationLevel, certificates: data.certificate }
      this.loading = true
      const result = await this.$store.dispatch('editEducations', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.$emit('reload', true)
        this.tab = 0
      }
    },
    deleteItem() {
      this.deleteDialog = true;
    },
    async deleteComponent(data) {
      const body = { ...data, addressType: data.type }
      this.loading = true
      const result = await this.$store.dispatch('deleteEducations', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_delete'))
        this.$emit('reload', true)
        this.tab = 0
        this.deleteDialog = false
      }
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', { type, msg })
    },
    refreshData(changeTab = true) {
      if (changeTab) this.tab = 0
      if (this.addressList) {
        this.formData = this.educationList
      } else {
        this.formData = []
        this.detail = { startDate: null, certificate: [] }
      }
    },
    reload() {
      this.$emit('reload', true)
    }
  },
  created() {
    this.getParentData()
    this.getEducationLevel()
  },
  watch: {
    educationList() {
      this.formData = this.educationList
      this.detail = {}
    },
    userId() {
      this.refreshData()
    },
    tab(tab) {
      if (this.$refs.form && !this.isEdit && tab == 1) {
          this.$refs.form.reset();
      }
    },
  }
}
</script>
<style scoped>
.sae-grey {
  background: #7c8a963d;
  line-height: 35px;
  cursor: pointer;
}
</style>